import { graphql, Link } from 'gatsby';
import React from 'react';
import { HOME_PAGE } from '../../../constants/page-links';
import WhiteDuxianaSiteLogoImage from '../../../images/duxiana-logo-white.inline.svg';
import { FooterListItem } from '../../lists/items/footer';
import { SITE_PRODUCTION_URL } from '../../../constants/global';

const Footer = ({ data }) => {
  const {
    allOptimizelyFooterContentTreeContentChildren: { edges: HomePageMenu }
  } = data;
  const backToStartPageText = 'Back to start page';
  const breadPayNode = [
    {
      node: {
        name: 'Financing',
        contentLink: {
          url: `${SITE_PRODUCTION_URL}/bread-pay`
        },
        child: [
          {
            name: 'Bread Pay™',
            showInMenu: true,
            contentLink: {
              url: `${SITE_PRODUCTION_URL}/bread-pay`
            }
          }
        ]
      }
    }
  ];
  const updatedHomePageMenu = HomePageMenu.concat(breadPayNode);
  return (
    <footer className="footer">
      <nav className="footer-navigation" aria-label="footer">
        <div className="footer__logo">
          <Link to={HOME_PAGE}>
            <WhiteDuxianaSiteLogoImage className="h-auto w-[120px]" />
            <span className="sr-only">{backToStartPageText}</span>
          </Link>
        </div>

        {updatedHomePageMenu && updatedHomePageMenu?.length > 0 && (
          <ul>
            {updatedHomePageMenu?.map((pageContent, idx) => (
              <FooterListItem key={idx} pageData={pageContent.node} />
            ))}
          </ul>
        )}
      </nav>
    </footer>
  );
};

export default Footer;

export const query = graphql`
  query {
    allOptimizelyFooterContentTreeContentChildren(sort: { sortOrder: ASC }, filter: { showInMenu: { eq: true } }) {
      edges {
        node {
          showInMenu
          contentLink {
            id
            url
          }
          name
          listHeading
          listSubHeading
          child {
            contentLink {
              url
            }
            name
            listHeading
            showInMenu
          }
        }
      }
    }
  }
`;
